import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dashboard } from "api/model/dashboard/Dashboard";
import { DashboardComponentGroup } from "api/model/dashboard/DashboardComponentGroup";
import { T } from "services/lang/LanguageService";
import { updateDashboardTabs } from "../../utils";

interface GroupTitleChangeDialogProps {
  dashboard: Dashboard;
  tabId: number;
  group: DashboardComponentGroup;
  groupTitleChangeDialogVisibility: boolean;
  setGroupTitleChangeDialogVisibility: (groupTitleChangeDialogVisibility: boolean) => void;
}

const GroupTitleChangeDialog = ({
  dashboard,
  tabId,
  group,
  groupTitleChangeDialogVisibility,
  setGroupTitleChangeDialogVisibility,
}: GroupTitleChangeDialogProps) => {
  const [newGroupTitle, setNewGroupTitle] = useState<string>(group.title || "");

  const handleSaveGroupTitle = () => {
    if (!dashboard) return;

    updateDashboardTabs(
      dashboard,
      dashboard?.dashboardTabsJs.map((tab, index) => {
        if (index === tabId) {
          return {
            ...tab,
            componentGroups: tab.componentGroups.map(g =>
              g.id === group.id ? { ...g, title: newGroupTitle } : g
            ),
          };
        }
        return tab;
      })
    );

    setGroupTitleChangeDialogVisibility(false);
  };

  const titleChangeFooter = () => (
    <div>
      <Button
        icon="pi pi-times"
        className="p-button-rounded p-button-text"
        onClick={() => setGroupTitleChangeDialogVisibility(false)}
      />
      <Button
        icon="pi pi-check"
        className="p-button-rounded p-button-text"
        onClick={handleSaveGroupTitle}
      />
    </div>
  );

  return (
    <Dialog
      header={T("action.change-group-title")}
      style={{ width: "20rem", height: "16rem" }}
      visible={groupTitleChangeDialogVisibility}
      onHide={() => setGroupTitleChangeDialogVisibility(false)}
      footer={titleChangeFooter}
    >
      <div>
        <div>{group.title}</div>
        <InputText
          value={newGroupTitle}
          className="w-full"
          onChange={e => setNewGroupTitle(e.target.value)}
        />
      </div>
    </Dialog>
  );
};

export default GroupTitleChangeDialog;
